import { Component } from '@angular/core';
import { UIActiveDialogService } from '../../../../shared/services/ui-dialog.service';

@Component({
  selector: 'bulk-add-assets-dialog',
  templateUrl:
    'console/app-js/modules/bulkAdd/shared/bulk-add-progress-dialog/bulk-add-progress-dialog.component.html'
})
export class BulkAddProgressDialog {
  constructor(public activeDialogService: UIActiveDialogService) {}

  ngOnDestroy(): void {
    // this.progressRef.complete();
  }

  onCancel(): void {
    this.activeDialogService.dismiss();
  }
}
